export function deprecated(component, deprecation, newProp) {
  if (__DEV__ && console && console.warn) {
    let parentName;
    let endMessage;

    try {
      parentName = this._reactInternalInstance._currentElement._owner._instance
        .__proto__.constructor.name;
    } catch (e) {
      parentName = null;
    }

    if (newProp) {
      endMessage = `please use ${newProp} instead.`;
    } else {
      endMessage = `please remove it.`;
    }

    console.warn(
      `[ELKE] Component ${component}: the ${deprecation} prop ${
        parentName ? ` used inside ${parentName}` : ''
      } is deprecated, ${endMessage}`
    );
  }
}
